export default __webpack_public_path__ + "static/media/Caro2.48dc8287.jpg";